import { render, staticRenderFns } from "./CardEventDonation.vue?vue&type=template&id=75b4d1c4"
import script from "./CardEventDonation.vue?vue&type=script&lang=js"
export * from "./CardEventDonation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports